import { useEffect } from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/home/Hero";
import { TrustStrip } from "../components/home/TrustStrip";
import { Services } from "../components/home/Services";
import { ProblemSolution } from "../components/home/ProblemSolution";
import { Process } from "../components/home/Process";
import { Stats } from "../components/home/Stats";
import { Testimonials } from "../components/home/Testimonials";
import { Faq } from "../components/home/Faq";
import { FinalCta } from "../components/home/FinalCta";
import { FloatingButtons } from "../components/FloatingButtons";
import { Footer } from "../components/Footer";
import { captureUtm } from "../lib/utm";

export default function Landing() {
  useEffect(() => {
    captureUtm();
  }, []);

  return (
    <div data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <Services />
        <ProblemSolution />
        <Process />
        <Stats />
        <Testimonials />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
